/**
 * Locale fuer Kategorie- und Attribut-Beschriftungen — EINE Quelle fuer die ganze App.
 *
 * Warum eine Konstante statt einer Storefront-Tabelle:
 *
 * Kauflands Katalog ist ueber alle Storefronts identisch. Am 2026-08-16 an der Live-DB
 * gemessen: neun gecrawlte Storefronts, je 6.090 Kategorien, gleiche IDs, gleiche
 * `parent_id`/`level`, ein einziger Fingerprint ueber alle Baeume. Dasselbe bei den
 * Attributen — gleiche `attribute_id`, gleicher `name`, gleicher `type`, gleiches
 * `is_required`, selbst deutsche Rechtsattribute (`battery_disposal_instruction`) stehen
 * unveraendert in der franzoesischen Kategorie. Uebersetzt ist ausschliesslich das
 * Anzeige-Label.
 *
 * Diese Beschriftungen sieht NUR der Haendler in unserer Oberflaeche. Was der Endkunde auf
 * kaufland.nl liest, kommt aus Kauflands eigenem Katalog — wir senden dorthin nur die
 * `id_category`. Die Locale ist damit reine Kosmetik und darf einheitlich deutsch sein.
 *
 * Was sie NICHT ist: die Sprache der Inhalte. Titel, Beschreibung und Attributwerte, die der
 * Haendler pflegt, gehoeren weiter in die Landessprache. Die Locale in
 * `kaufland-find-product-by-ean-v2` bleibt deshalb bewusst storefront-abhaengig — sie
 * befuellt einen Listing-Entwurf mit Inhalt, nicht mit Beschriftungen.
 *
 * SCHLUESSELBILDEND: Der Wert geht als `_locale` in `kaufland_get_mapping_profile`,
 * `kaufland_set_mapping_field` und `kaufland_save_mapping_profile` ein. Bis 2026-08-16 stand
 * die Ableitung vierfach im Repo (Editor, Reiter "Optionale Felder", Vorschau,
 * Varianten-Overlay) — und die vier Kopien kannten nur sieben Storefronts, waehrend die RPC
 * seit Migration 0041 zehn kennt. Fuer `nl` speicherte das Frontend sein Profil deshalb unter
 * `de-DE`, waehrend der Attribut-Cache unter `nl-NL` lag. Genau diese Drift schliesst die
 * Konstante aus.
 */
export const LISTING_LOCALE = 'de-DE';

/**
 * Locale fuer eine Storefront. Nimmt die Storefront weiterhin entgegen, damit die Aufrufer
 * lesbar bleiben ("welche Locale gilt hier?") und ein spaeterer Ruecklauf auf
 * storefront-abhaengige Beschriftungen nur diese Funktion aendern muss.
 */
export function localeForStorefront(_storefront: string): string {
  return LISTING_LOCALE;
}
